import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { Karaoke as KaraokeOverlay } from './Overlays/Karaoke'


/**
 * COMPONENTE: KARAOKE OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:karaoke".
 * 2. Escucha los mensajes entrantes.
 * 3. Pasa la información al componente visual <Karaoke />.
 * ------------------------------------------------------------------
 */
const Karaoke = () => {
    
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [karaokeData, setKaraokeData] = useState(null); // Payload para el hijo
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
    // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        
        // 1. Definir la función de conexión
        const connect = async () => {
            // Llamamos a la nueva función del BL especificando 'karaoke'
            await ConnectWebSocketForOverlay(
                'karaoke', 
                (status) => setConnectionStatus(status),
                (msg) => console.log('[Overlay] Toast:', msg) // O tu lógica de toast
            );

            // Asignamos el manejador de mensajes
            SetSocketMessageHandler(handleIncomingMessage);
        };

        // 2. Definir el manejador de mensajes (El "Switch")
        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            // Filtramos solo los mensajes relevantes para Karaoke
            // Nota: En el controller C# definimos el type = "karaoke"
            if (message.type.toLowerCase() === 'karaoke') {
                // Pasamos el objeto 'data' completo al hijo
                // data contiene: { action: 'show_lyric', text: '...', ... }
                setKaraokeData(message.data);
            }
        };

        // 3. Ejecutar conexión
        connect();

        // 4. Cleanup al desmontar
        return () => {
            ClearSocketMessageHandler();
            DisconnectWebSocket();
        };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket.
                Si tuvieras lógica de Modo Femenil, pásala aquí también.
            */}
            <KaraokeOverlay data={karaokeData} /> {/* isActiveWomensMode={isActiveWomensMode} */}

            {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10 }}>D</div>
            )}
        </>
    );
};

export { Karaoke };